import { useEffect, useRef, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Input } from "@/components/ui/input";

const toDisplay = (iso) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "");

const toIso = (txt) => {
  const m = txt.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return null;
  const [d, mo, y] = [+m[1], +m[2], +m[3]];
  const dt = new Date(y, mo - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
  return `${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
};

const mask = (raw) => {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)].filter(Boolean).join("/");
};

export const DateInput = ({ value, onChange, min, className = "", "data-testid": testId, ...rest }) => {
  const [text, setText] = useState(toDisplay(value));
  const picker = useRef(null);
  useEffect(() => {
    setText(toDisplay(value));
  }, [value]);
  const emit = (iso) => onChange?.({ target: { value: iso } });
  const onType = (e) => {
    const v = mask(e.target.value);
    setText(v);
    const iso = toIso(v);
    if (iso) emit(iso);
    else if (!v) emit("");
  };
  return (
    <div className={`relative ${className.split(/\s+/).filter((c) => /^(\w+:)?w-/.test(c)).join(" ")}`}>
      <Input {...rest} value={text} onChange={onType} onBlur={() => setText(toDisplay(value))} placeholder="ηη/μμ/εεεε"
        inputMode="numeric" className={`${className} pr-9`} data-testid={testId} />
      <button type="button" tabIndex={-1} onClick={() => picker.current?.showPicker?.()} data-testid={testId ? `${testId}-picker` : undefined}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 transition-colors">
        <CalendarDays className="h-4 w-4" />
      </button>
      <input ref={picker} type="date" value={value || ""} min={min} onChange={(e) => emit(e.target.value)} tabIndex={-1} aria-hidden
        className="absolute right-0 bottom-0 h-0 w-0 opacity-0 pointer-events-none" />
    </div>
  );
};
